import { render } from "./AppointmentForm.vue?vue&type=template&id=4ca48e98&scoped=true"
import script from "./AppointmentForm.vue?vue&type=script&lang=js"
export * from "./AppointmentForm.vue?vue&type=script&lang=js"

import "./AppointmentForm.vue?vue&type=style&index=0&id=4ca48e98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca48e98"]])

export default __exports__